import { createSlice } from '@reduxjs/toolkit';

const initialState = { txnID: null, vendID: null };

export const txn = createSlice({
    name: 'txn',
    initialState,
    reducers: {
        _setTxnID: (state, action) => {
            return { ...state, txnID: action.payload };
        },
        setVendID: (state, action) => {
            state.vendID = action.payload ?? null
        },
        _flushTxnID: () => initialState,
    },
});

export const { _setTxnID, _flushTxnID, setVendID } = txn.actions;

export default txn.reducer;
